import { Dispatch } from "react";
import { TableColumn } from "react-data-table-component";
import TableData from "../../Component/Ecommerce/List/TableData";

type Cols<T> = TableColumn<T> & any[];

const EBSSSTable = ({
  data,
  cols = [],
  topAction,
  sortFunc,
  pageHandler,
  onRowClicked,
}: {
  data: any;
  cols: Cols<any>;
  topAction?: React.ReactNode | React.ReactNode[];
  sortFunc?: Function;
  pageHandler?: Dispatch<number>;
  onRowClicked?: (row: any) => void;
}) => {
  //@ts-ignore
  return (
    <TableData
      data={data}
      columns={cols?.map((c) => {
        return {
          ...c,
          sortFunction: c.column ? () => sortFunc(c.column) : null,
        };
      })}
      pageHandler={pageHandler}
      topAction={topAction}
      onRowClicked={onRowClicked}
    />
  );
};

export default EBSSSTable;
